<template>
  <div class="rich-text-main">
<!--    <div class="quill-editor"-->
<!--         v-model="content"-->
<!--         v-quill:myQuillEditor="editorOption">-->
<!--    </div>-->
    <quill-editor :options="editorOption" v-model="content"></quill-editor>
  </div>
</template>
<script>
	// 引入 Quill 样式
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'

	import { quillEditor } from 'vue-quill-editor'

	export default {
		name: 'richText',
		props: {
			value: {
				type: String,
				default: ''
			},
			placeholder: {
				type: String,
				default: '请填写描述信息'
			}
		},
		data () {
			return {
				content: '',
				editorOption: {
					placeholder: this.placeholder,
					modules: {
						toolbar: {
							container: [ [
								'undo',
								'redo',
								{ 'list': 'bullet' },
								{ 'list': 'ordered' },
								{ 'indent': '-1' },
								{ 'indent': '+1' },
								'bold',
								'italic',
								'underline',
								'link',
								'clean',
							] ],
							handlers: {
								redo () {
									this.quill.history.redo()
								},
								undo () {
									this.quill.history.undo()
								}
							}
						}
					}
				}
			}
		},
		watch: {
			// value: {
			// 	keep: true,
			// 	immediate: true,
			// 	handler: function (value) {
			// 		this.content = value
			// 	}
			// },
			// content: {
			// 	keep: true,
			// 	immediate: true,
			// 	handler: function (value) {
			// 		this.$emit('input', value)
			// 		this.$emit('change', value)
			// 	}
			// }
		},
    components: {
			quillEditor
    },
		mounted () {
			this._initButton()
		},
		methods: {
			// 添加回退和前进按钮
			_initButton () {
				const undo = document.querySelector('.ql-undo')
				const redo = document.querySelector('.ql-redo')
				undo.innerHTML = '<img src="https://files.wondercv.com/cvs/undo.png"/>'
				redo.innerHTML = '<img src="https://files.wondercv.com/cvs/redo.png"/>'
			}
		}
	}
</script>
<style lang="scss">
  .rich-text-main {
    // height: 260px;
    // padding-bottom: 20px;
    border-color: #DCDFE6 !important;
    * {
      border-color: #DCDFE6 !important;
    }
    .quill-editor {
      height: 218px;
      b,
      strong {
        font-weight: 700;
      }
      sub {
        vertical-align: sub;
        font-size: smaller;
      }
      sup {
        vertical-align: super;
        font-size: smaller;
      }
    }
    .ql-undo, .ql-redo {
      display: flex;
      align-items: center;
      img {
        width: 16px;
        height: 16px;
      }
    }
    svg {
      color: #606060;
      &:hover {
        .ql-snow .ql-stroke {
          stroke: #606060 !important;
        }
      }
    }
    .ql-formats {
      width: 100%;
      display: flex;
      justify-content: space-around;
    }
    .ql-tooltip.ql-editing {
      left: 75px !important;
    }
    .ql-snow .ql-tooltip[data-mode=link]::before {
      content: '链接';
    }
    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
      content: "保存";
    }
    .ql-snow .ql-stroke {
      stroke: #909090;
    }
    .ql-snow.ql-toolbar button,
    .ql-snow .ql-toolbar button,
    .ql-snow.ql-toolbar button,
    .ql-snow .ql-toolbar button,
    .ql-snow.ql-toolbar button,
    .ql-snow .ql-toolbar button,
    .ql-snow.ql-toolbar .ql-picker-label,
    .ql-snow .ql-toolbar .ql-picker-label,
    .ql-snow.ql-toolbar .ql-picker-label,
    .ql-snow .ql-toolbar .ql-picker-label,
    .ql-snow.ql-toolbar .ql-picker-item,
    .ql-snow .ql-toolbar .ql-picker-item,
    .ql-snow.ql-toolbar .ql-picker-item,
    .ql-snow .ql-toolbar .ql-picker-item {
      color: #909090 !important;
    }
    .ql-snow.ql-toolbar button:hover,
    .ql-snow .ql-toolbar button:hover,
    .ql-snow.ql-toolbar button:focus,
    .ql-snow .ql-toolbar button:focus,
    .ql-snow.ql-toolbar button.ql-active,
    .ql-snow .ql-toolbar button.ql-active,
    .ql-snow.ql-toolbar .ql-picker-label:hover,
    .ql-snow .ql-toolbar .ql-picker-label:hover,
    .ql-snow.ql-toolbar .ql-picker-label.ql-active,
    .ql-snow .ql-toolbar .ql-picker-label.ql-active,
    .ql-snow.ql-toolbar .ql-picker-item:hover,
    .ql-snow .ql-toolbar .ql-picker-item:hover,
    .ql-snow.ql-toolbar .ql-picker-item.ql-selected,
    .ql-snow .ql-toolbar .ql-picker-item.ql-selected {
      color: #404040 !important;
    }
    .ql-snow.ql-toolbar button:hover .ql-stroke,
    .ql-snow .ql-toolbar button:hover .ql-stroke,
    .ql-snow.ql-toolbar button:focus .ql-stroke,
    .ql-snow .ql-toolbar button:focus .ql-stroke,
    .ql-snow.ql-toolbar button.ql-active .ql-stroke,
    .ql-snow .ql-toolbar button.ql-active .ql-stroke,
    .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,
    .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,
    .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,
    .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,
    .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,
    .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,
    .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
    .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,
    .ql-snow.ql-toolbar button:hover .ql-stroke-miter,
    .ql-snow .ql-toolbar button:hover .ql-stroke-miter,
    .ql-snow.ql-toolbar button:focus .ql-stroke-miter,
    .ql-snow .ql-toolbar button:focus .ql-stroke-miter,
    .ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,
    .ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,
    .ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
    .ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,
    .ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
    .ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,
    .ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
    .ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,
    .ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,
    .ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter {
      stroke: #404040;
    }
    ul, ol {
      padding: 0;
    }

    .ql-blank::before {
      color: #AFAFB7;
      font-style: normal;
    }
    .ql-formats {
      button {
        position: relative;
        &::before {
          content: "";
          display: none;
          width: 0;
          height: 0;
          border-color: transparent;
          border-style: solid;
          border-width: 5px;
          border-bottom-color: rgba(0, 0, 0, .7);
          position: absolute;
          bottom: -2px;
          left: 50%;
          transform: translateX(-50%);
          z-index: 9;
        }
        &::after {
          content: "123123";
          display: none;
          padding: 4px 8px;
          background: rgba(0, 0, 0, .7);
          position: absolute;
          bottom: -2px;
          left: 50%;
          transform: translate(-50%, 100%);
          font-size: 14px;
          border-radius: 2px;
          color: #fff;
          z-index: 9;
          word-break: keep-all; // 不换行
          white-space: nowrap;
        }
        &:hover::before,
        &:hover::after {
          display: block;
        }
        &.ql-undo::after {
          content: "撤销";
        }
        &.ql-redo::after {
          content: "重复";
        }
        &.ql-list[value="bullet"]::after {
          content: "项目符号";
        }
        &.ql-list[value="ordered"]::after {
          content: "编号列表";
        }
        &.ql-indent[value="-1"]::after {
          content: "减少缩进";
        }
        &.ql-indent[value="+1"]::after {
          content: "增加缩进";
        }
        &.ql-bold::after {
          content: "粗体";
        }
        &.ql-italic::after {
          content: "斜体";
        }
        &.ql-underline::after {
          content: "下划线";
        }
        &.ql-link::after {
          content: "插入/编辑链接";
        }
        &.ql-clean::after {
          content: "清除格式";
        }
      }
    }
    .ql-toolbar.ql-snow {
      border-radius: 4px 4px 0 0;
    }
    .quill-editor.ql-container.ql-snow {
      border-radius: 0 0 4px 4px;
    }
  }
</style>
